export const invoiceData = {
    registeredAddress: "104, Vasan Udhyog Bhavan, Sunmill Compound, Tulsi Pipe Road, Lower Parel (W), Mumbai-400013 | CIN - U74999MH2017PLC291558",
    supportEmail: "support@nykaa.com",
    jurisdiction: "Mumbai",
    orderNumber: "NYK-203938340-2296993-1",
    orderDate: "28/04/2024",
    shippingAddress: `Shalini
  D 401 Neelpadam Kunj
  Sector 1 Vaishali Ghaziabad
  Ghaziabad, Uttar Pradesh,
  INDIA - 201010`,
    billingState: "Delhi",
    placeOfSupply: "Uttar Pradesh",
    buyerUID: "ND2486405659",
    invoiceNumber: "ND2016866980",
    items: [
      {
        description: "Rica Strawberry Liposoluble Wax For Dry Skin With Glyceryl Rosinate & Natural Beeswax(800ml)",
        salePrice: "1188.00",
        quantity: "1",
        discount: "0.00",
        cgst: "18.00",
        sgst: "18.00",
        igst: "0.00",
        netAmount: "1188.00"
      },
      {
        description: "COD Charge",
        salePrice: "0.00",
        quantity: "0",
        discount: "0.00",
        cgst: "0.00",
        sgst: "0.00",
        igst: "0.00",
        netAmount: "0.00"
      },
      {
        description: "Shipping Charge",
        salePrice: "0.00",
        quantity: "0",
        discount: "0.00",
        cgst: "0.00",
        sgst: "0.00",
        igst: "0.00",
        netAmount: "0.00"
      }
    ],
    totalDetails: {
      discount: "0.00",
      wallet: "0.00",
      gvValue: "0.00",
      taxAmount: "181.22",
      stateEntryTax: "0.00",
      roundOff: "0.00",
      grandTotal: "1188.00",
      refundAmount: "0",
    },
    declaration: "I : Tax is not payable on reverse charge basis.\nCUSTOMER SELF DECLARATION: I, Hereby confirm that the content of this package are being purchased for my internal and personal purpose and not for resale. I further understand and agree to Nykaa's Terms and Conditions."
  };
  